export default __webpack_public_path__ + "static/010-c0e5f5a9596e4954d4c30b529d1dff0d.jpg";